'use client';

import { Button } from '@/components/ui/button';
import { ScrollArea } from '@/components/ui/scroll-area';
import { IconChevronLeft } from '@tabler/icons-react';
import clsx from 'clsx';
import { useTranslations } from 'next-intl';

type Props = {
  title: string;
  onBack: () => void;
  toolbar?: React.ReactNode;
  footer?: React.ReactNode;
  children: React.ReactNode;
  bodyClassName?: string;
};

export function FilterSubPanel({ title, onBack, toolbar, footer, children, bodyClassName }: Props) {
  const t = useTranslations();

  return (
    <div className='flex h-full min-h-0 flex-col bg-white animate-in fade-in-0 slide-in-from-end-8 duration-200'>
      <div className='flex shrink-0 items-center gap-[8px] border-b border-primary-stroke-day px-[8px] py-[10px]'>
        <Button
          variant='ghost'
          size='icon'
          onClick={onBack}
          aria-label={t('controls.categorySelect.back')}
          className='size-[40px] shrink-0 rounded-full hover:bg-bg2-day active:scale-95'
        >
          <IconChevronLeft className='size-[22px] text-text-primary-day rtl:rotate-180' />
        </Button>
        <h3 className='min-w-0 truncate text-[18px] font-semibold text-text-primary-day'>{title}</h3>
      </div>

      {toolbar && <div className='shrink-0 px-[16px] pt-[12px]'>{toolbar}</div>}

      <ScrollArea className='min-h-0 flex-1 [&>[data-slot=scroll-area-viewport]>div]:block!'>
        <div className={clsx('px-[16px] py-[12px]', bodyClassName)}>{children}</div>
      </ScrollArea>

      {footer && (
        <div className='shrink-0 border-t border-primary-stroke-day px-[16px] pt-[12px] pb-[calc(12px+env(safe-area-inset-bottom))]'>
          {footer}
        </div>
      )}
    </div>
  );
}
